/**
 * Created by renatolovizotto on 12/07/17.
 */
import React, {Component} from "react";
import {inject, observer} from "mobx-react";
import Select from 'react-select';
import 'react-select/dist/react-select.css';
import "../assets/stylesheets/DropdownFilter.scss";

@inject('Navigator', 'AuthStore', 'SchoolStore')
@observer
export default class DropdownSchool extends Component {


    /*
    ##############
    # Load UNITS #
    ##############
    */
    componentWillMount() {

        /*
        //Busca Usuário Logado
        const {user} = this.props.AuthStore;
        const params = {
            'id_sf_teacher': user.id
        };
        // Is Hardcoded user
        if (this.props.AuthStore.units.length === 0) {
            this.props.SchoolStore.getUnits(params);
        } else {
            // Ordinary user
            this.props.SchoolStore.units = this.props.AuthStore.units;
        }
        */

        //Seta Unidades vindas do Login
        this.props.SchoolStore.units = this.props.AuthStore.units;

    }

    /*
    ###################################
    # Change/Set SCHOOL -> Load CLASS #
    ###################################
    */
    handleChangeSchool(schoolSelected) {

        /*
            value: "0013600000NBTM4AAP", 
            label: "WUP Portão"
        */

        var id = '';

        //??
        if (schoolSelected.id  != undefined  && schoolSelected.id.length > 0 ){
            id = schoolSelected.id;
        } 
        else {
            id = schoolSelected.value;
        }
        //Busca Usuário Logado
        const {user} = this.props.AuthStore;

        //Busca SchoolStore
        var SchoolStore = this.props.SchoolStore;

        //Seta School Selecionada na Store
        SchoolStore.schoolSelected = schoolSelected;

        //Zera Class e Lesson Selecionada na Store
        SchoolStore.classSelected = null;
        SchoolStore.lessonSelected = null;

        //Limpa o Array de Students na Store
        SchoolStore.students = [];
        SchoolStore.studentsEngagement = [];

        //Limpa GroupProgress na Store
        SchoolStore.groupProgress = 0;

        //Chama API
        SchoolStore.getClassesBySchool(id,user);
        this.props.SchoolStore.msgAttendance = "";
    }
   

    render() {

        //Options do Select de Units
        var optionsUnit = [];
        this.props.SchoolStore.units.forEach(unitsToOptions);
        function unitsToOptions(item) {
            optionsUnit.push({ value: item.id, label: item.name} );
        }

        return (

                <Select
                    name="school"
                    options={optionsUnit}
                    onChange={this.handleChangeSchool.bind(this)}
                    placeholder="Selecione a unidade"
                    className="Dropdown"
                    value={this.props.SchoolStore.schoolSelected}
                />

        );
        
    }

}


// WEBPACK FOOTER //
// ./src/containers/DropdownSchool.js